export const adaptSolicitudGestLogistica = (solicData) => {
    return {
        idDelegacion: solicData?.idDelegacion,
        nroInstancia: solicData?.instanciaLogistica?.length,
        instancias: solicData?.instanciaLogistica,
        nroContrato: solicData?.idEvaluacion,
        tipoContrato: solicData?.tipoContrato,
        paciente: solicData?.t_EvaluacionPaciente?.idPacienteNavigation?.nombre + ' ' + solicData?.t_EvaluacionPaciente?.idPacienteNavigation?.apellido,
        idPaciente: solicData?.t_EvaluacionPaciente?.idPacienteNavigation?.idPaciente,
        codSapPaciente: solicData?.t_EvaluacionPaciente?.idPacienteNavigation?.codSAPPaciente,
        fechaDesdeContrato: solicData?.fechaDesde,
        fechaHastaContrato: solicData?.fechaHasta,
        precioDiario: solicData?.precioDiario,
        idEvaluacion: solicData?.idEvaluacion,
        ultimaInstancia: solicData?.idUltimaInstanciaLogisticaNavigation,
        t_EvaluacionPaciente : solicData?.t_EvaluacionPaciente
    }
}

export const adaptSolicitudGestLogisticaArray = (
    solicitudesGestionLogisticaData
) => {
    return structuredClone(solicitudesGestionLogisticaData?.allSolicitudesGestionLogistica?.items)
        ?.map(solic => adaptSolicitudGestLogistica(solic));
}